module.exports = __webpack_public_path__ + "static/media/GONG-ink-min.49e10b1e.jpeg";